import { render } from "./MultiSelectField.vue?vue&type=template&id=ae4c3daa"
import script from "./MultiSelectField.vue?vue&type=script&lang=js"
export * from "./MultiSelectField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectField.vue"]])

export default __exports__